import type { BodyMetric } from '../types'

/**
 * Stored in metric units. BMI is absent on purpose: it is calculated from
 * weight and height and must never be manually editable.
 */
export const bodyMetrics: BodyMetric[] = [
  { id: 'age', kind: 'years', value: 34, editable: true },
  { id: 'weight', kind: 'weight', value: 62.4, editable: true },
  { id: 'height', kind: 'height', value: 168, editable: true },
  { id: 'ffm', kind: 'weight', value: 46.8, editable: true },
  { id: 'bodyFat', kind: 'percent', value: 25, editable: true },
  { id: 'water', kind: 'percent', value: 52.3, editable: true },
  { id: 'bmr', kind: 'kcal', value: 1385, editable: true },
]

/** Metrics the user starts with visible on the profile. */
export const defaultHiddenBodyMetrics: string[] = ['bmr']

/**
 * Individual metrics published on the public profile (sport and body ids).
 * EMPTY by default: every performance and health metric is private until the
 * user explicitly selects it — and its category toggle is also on.
 */
export const defaultPublicMetrics: string[] = []
